import React from 'react'
import { FormControl, InputGroup, Button, Alert } from 'react-bootstrap'

const emailRegex = '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'

export default class ResendActivationCode extends React.Component {

  constructor(props) {
    super(props)
    this.state = { 
      email: props.email, 
      error: undefined, 
      success: undefined, 
      dirty: true,
     }
  }

  onChange(e) {
    this.setState({
      email: e.target.value, 
      dirty: true, 
      error: undefined, 
      success: undefined,
    })
  }

  submit() {
    this.props.callback(this.state.email)
  }

  validate(e) {
    e.preventDefault()
    const isEmailValid = new RegExp(emailRegex).test(this.state.email)

    if (isEmailValid && this.state.dirty) {
      this.setState({error: undefined, success: 'De activatiecode is verstuurd.', dirty: false})
      this.submit()
    } else if (!isEmailValid) {
      this.setState({error: 'Geen geldig e-mailadres', success: undefined})
    }
  }

  render() {
      if (!this.props.email) {
		  return null
	  }
	  
    return <form className='resend-activation-code' onSubmit={this.validate.bind(this)}>
      { this.state.error && <Alert bsStyle='danger'>{this.state.error}</Alert>}
      { this.state.success && <Alert bsStyle='success'>{this.state.success}</Alert>}
      <InputGroup>
        <FormControl 
          type='text' 
          value={this.state.email} 
          id='email' 
          placeholder='E-mailadres' 
          onChange={(e) => this.onChange(e)} 
        />
        <InputGroup.Button type='submit'>
          <Button type='submit' bsStyle='success'>Versturen</Button>
        </InputGroup.Button>
      </InputGroup>
    </form>
  }
}
